import { render, staticRenderFns } from "./v2024.vue?vue&type=template&id=e5783b2c&scoped=true&"
import script from "./v2024.vue?vue&type=script&lang=js&"
export * from "./v2024.vue?vue&type=script&lang=js&"
import style0 from "./v2024.vue?vue&type=style&index=0&id=e5783b2c&scoped=true&lang=css&"
import style1 from "./v2024.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5783b2c",
  null
  
)

export default component.exports